"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
exports.default = (function (_a) {
    var createElement = _a.createElement, getCardComponent = _a.getCardComponent;
    return function (_a) {
        var type = _a[0], payload = _a[1];
        return createElement(getCardComponent(type) ||
            utils_1.throwError("Unhandled card: `getCardComponent('" + type + "')` did not return a corresponding component."), { payload: payload });
    };
});
